/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Workspace_Aside_Details_DescInputs */

const en_directory_submit_workspace_aside_details_desc = /** @type {(inputs: Directory_Submit_Workspace_Aside_Details_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the URL and existing listings.`)
};

const zh_directory_submit_workspace_aside_details_desc = /** @type {(inputs: Directory_Submit_Workspace_Aside_Details_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查网址和已有条目。`)
};

/**
* | output |
* | --- |
* | "Check the URL and existing listings." |
*
* @param {Directory_Submit_Workspace_Aside_Details_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_workspace_aside_details_desc = /** @type {((inputs?: Directory_Submit_Workspace_Aside_Details_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Workspace_Aside_Details_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_workspace_aside_details_desc(inputs)
	return zh_directory_submit_workspace_aside_details_desc(inputs)
});
export { directory_submit_workspace_aside_details_desc as "directory.submit.workspace.aside.details_desc" }